// extracted by mini-css-extract-plugin
export default {"title":"ApplicationTermsOfUse_title__SsPU8","skeletonPWATermsAndCondition":"ApplicationTermsOfUse_skeletonPWATermsAndCondition__fDU7R"};